import React from "react";
import { Scale, Hash, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const UnitForm = ({ form, errors, handleInputChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Scale size={14} />}
        label="Unit Name"
        required
        field="unitName"
        value={form.unitName}
        onChange={handleInputChange}
        error={errors.unitName}
        placeholder="e.g. Square Feet, Pieces"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Unit Code"
        required
        field="unitCode"
        value={form.unitCode}
        onChange={handleInputChange}
        error={errors.unitCode}
        placeholder="e.g. SQFT, PCS"
      />
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Unit details..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
